import { setRequestParams } from '../../../lib/setRequestParams';



export default class AbTestMonitoringService {
  constructor (Api) {
    this.api = Api;
  }

  getAbTestsList (params) {
    return this.api.get(`ab-tests${setRequestParams(params)}`);
  }

  deleteAbTest ({ abTestId }) {
    return this.api.delete(`ab-tests/${abTestId}`);
  }
}
